import { Routes } from '@angular/router';
import { MaterialListComponent } from './components/material-scanner/material-list/material-list.component'
import { MaterialScanComponent } from './components/material-scanner/material-scan/material-scan.component'
import { MaterialCompareComponent } from './components/material-scanner/material-compare/material-compare.component'
import { MaterialVersionListComponent } from './components/material-scanner/material-version-list/material-version-list.component'

export const APP_ROUTES: Routes = [
     { path: 'material-list/:camp_id/:box_id', component: MaterialListComponent },
     { path: 'material-list/:camp_id/:box_id/:sesion', component: MaterialListComponent },
     { path: 'material-scan/:payload', component: MaterialScanComponent },
     { path: 'material-scan/:claw_camp_id/:camp_id/:group_id/:mat_name/:mat_id', component: MaterialScanComponent },
     { path: 'material-compare/:payload', component: MaterialCompareComponent },
     { path: 'material-version-list/:claw_camp_id/:camp_id/:box_id/:mat_id', component: MaterialVersionListComponent },
     { path: 'material-version-list/:claw_camp_id/:camp_id/:box_id/:mat_id/:sesion', component: MaterialVersionListComponent },
];
